import RFQDetails from 'Models/RFQ/RFQDetails';
import CargoInfo from 'Models/RFQ/CargoInfo';
import Trip from 'Models/Trip';
import Group from 'Models/Group';
// import Branch from 'Models/Branch';
import Transporter from 'Models/Transporter';
import Status from '../Status';
import BiddingDetails from 'Models/BiddingDetails';
import Bid from 'Models/Bid';
import { getUser } from 'Utils/storage';
import { COROMANDEL, ROQUETTE, VISHAKA } from 'Constants/commonConstants';
import { isFosroc, isDesmet } from 'Utils';

function flattenDeep(arr1) {
   return arr1.reduce((acc, val) => Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val), []);
}

const setDefaultContractToDate = () => {
   const date =  new Date();
   let toDate = "";
   if(isFosroc()) {
      toDate = new Date(date.getFullYear() + 1, date.getMonth(), date.getDate()-1);
   } else if(isDesmet()) {
      toDate = date.setDate(date.getDate() + 4);
   }
   return toDate;
}


const initialRFQ = {
   rfq_type: 1,
   event_id: '',
   rfq_details: {
      rfq_name: '',
      contract_tenure: {
         from: new Date().setHours(0, 0, 0, 0),
         to: setDefaultContractToDate()
      },
      service_type: 1,
      service_type_name: 'FTL',
      service_modes: (VISHAKA.includes(getUser().companyId)) ? [1] : [5],
      insurance_by: 0,
      bidding_details: {
         is_allow_bidding: true,
         is_accept_partial_solution: true,
         is_bidding_percentage_solution: false
      },
      contract_note: "",
      tk11_type : "" ,
      tk11_type_name: "" ,
      sales_organisation_type: [],

   },
   cargo_info: {
      cargo_details: [],
      cargo_description: "",
      packing_type: 0,
      handling_instructions: [],
      temperature_sensitive: {
         is_sensitive: false,
         min: 100,
         max: 150,
         unit: 1
      }
   },
   trip_details: {
      trips: [],
   },
   bidding_and_payments: {
      bidding_start: null,
      bidding_end: null,

      pricing_basis: 0,
      pricing_basis_name: "",

      payment_terms: (ROQUETTE.includes(getUser().companyId)) ? 3 : 2,

      payment_cycle: 0,
      payment_cycle_name: "",

   },
   docs_and_transporters: {
      transporters: {
         is_all_transporters: false,
         transporter_details: [],
         groups: []
      },
      docs: []
   },
   subplant_name: [],
   contracting_type :[]
}

export default class RFQ {
   constructor(rfq = initialRFQ) {
      //this.id = 'b9ac0f067df14007a49b533244076570';
      this.id = rfq.rfq_id || undefined;
      this.rfq_name = rfq.rfq_name || '';
      this.event_id = rfq.event_id || undefined;
      this.isDraft = rfq.is_draft || true;
      this.type = rfq.rfq_type;
      this.companyId = rfq.company_id || undefined;
      this.companyName = rfq.company_name || undefined;
      this.companyBranch = rfq.company_branch || undefined;
      this.businessVolume = rfq.business_volume || undefined;
      this.rfqStatus = rfq.status;
      this.status = rfq.status && Object.keys(rfq.status).length > 0 && new Status(rfq.status) || {};
      this.rfqNumber = rfq.rfq_number || undefined;
      rfq.rfq_details['multi_level_movement_type'] = rfq.multi_level_movement_type;
      rfq.rfq_details['shipping_type'] = rfq.shipping_type;
      rfq.rfq_details['includes_other_charges'] = rfq.includes_other_charges;
      rfq.rfq_details['secondary_contract_type'] = rfq.secondary_contract_type;
      rfq.rfq_details['courier_price_weight'] = rfq.courier_price_weight;
      rfq.rfq_details['courier_tat_weight'] = rfq.courier_tat_weight;
      rfq.rfq_details['cha_id'] = rfq.cha_id;
      rfq.rfq_details['cha_name'] = rfq.cha_name;
      rfq.rfq_details['bound_type'] = rfq.bound_type;
      rfq.rfq_details['trip_level_transporter'] = rfq.trip_level_transporter;
      rfq.rfq_details['rfq_type_ltc'] = rfq.rfq_type_ltc;
      rfq.rfq_details['rfq_type'] = rfq.rfq_type;
      rfq.rfq_details['fuel_name'] = rfq.fuel_name;
      rfq.rfq_details['tk11_table'] = rfq.tk11_table;
      rfq.rfq_details['tk11_type'] = rfq.tk11_type || rfq.rfq_details['tk11_type'];
      rfq.rfq_details['tk11_type_name'] = rfq.tk11_type_name || rfq.rfq_details['tk11_type_name'];
      rfq.rfq_details['sales_organisation_type'] = rfq.sales_organisation_type || rfq.rfq_details['sales_organisation_type'];
      rfq.rfq_details['incoTerms'] = rfq.incoTerms;
      rfq.rfq_details['incoTermsName'] = rfq.incoTerms_name;
      rfq.rfq_details['movement_type_name'] = rfq.original_rfq_id ? 'Spot' : rfq.movement_type_name;
      rfq.rfq_details['movement_type'] = rfq.original_rfq_id ? 1 : rfq.movement_type;
      rfq.rfq_details['bidding_type'] = rfq.bidding_type || 1;
      rfq.rfq_details['with_pincode'] = rfq.with_pincode || 2;
      rfq.rfq_details['contract_type'] = rfq.contract_type;
      rfq.rfq_details['contract_type_name'] = rfq.contract_type_name;
      rfq.rfq_details['contract_note'] = rfq.contract_note;
      rfq.rfq_details['other_remarks'] = rfq.other_remarks || '';
      rfq.rfq_details['ftl_contract_type'] = rfq.ftl_contract_type || 1;
      rfq.rfq_details['vendor_bidding_screen_id'] = rfq.vendor_bidding_screen_id;
      rfq.rfq_details['vendor_bidding_screen'] = rfq.vendor_bidding_screen;
      rfq.rfq_details['disposal_contract_type'] = rfq.disposal_contract_type;
      rfq.rfq_details["dedicated_type"] = rfq.dedicated_type;
      rfq.rfq_details["project_details"] = rfq.project_details;
      rfq.rfq_details["material_packing_list"] = rfq.material_packing_list;
      rfq.rfq_details["contact_details"] = rfq.contact_details;
      rfq.rfq_details["supplier_docs"] = rfq.supplier_docs;
      rfq.rfq_details["supplier_instruction"] = rfq.supplier_instruction;
      rfq.rfq_details["supplier_number"] = rfq.supplier_number;
      rfq.rfq_details["supplier_rfq"] = rfq.supplier_rfq;
      rfq.rfq_details["supplier_rfq_id"] = rfq.supplier_rfq_id;
      rfq.rfq_details["product_category_name"] = rfq.product_category_name;
      rfq.rfq_details['service_mode_name'] = ((rfq.service_mode || [])[0] || {}).name;
      rfq.rfq_details['enable_pincode_columns'] = rfq.enablePincodeColumns;
      rfq.rfq_details['validate_pincode_on_upload'] = rfq.validatePincodeOnUpload;
      this.rfqDetails = new RFQDetails(rfq.rfq_details);
      this.minBidders = rfq.minBidders;
      this.noOfCounterpriceAccepted = rfq.no_of_counter_priceAccepted;
      this.noOfCounterpricePending = rfq.no_of_counter_pricePendding;
      this.noOfCounterpriceRejected = rfq.no_of_counter_priceRejected;
      this.noOfCounterpriceSent = rfq.no_of_counter_priceSent;
      this.noOfLoiAccepted = rfq.no_of_loiAccepted;
      this.noOfLoiRejected = rfq.no_of_loiRejected;
      this.noOfLoiReceived = rfq.no_of_loiReceived;
      this.noOfLoiSent = rfq.no_of_loiSent;
      this.pending = rfq.pending;
      this.hideTransportersName = rfq.hideTransportersName;
      this.displayBaseVolume = rfq.displayBaseVolume;
      this.serviceTypeName = rfq.service_type_name;
      this.challengePriceWithAcceptOrReject = rfq.challenge_price_with_accept_or_reject;
      this.challengePriceWithCounter = rfq.challenge_price_with_counter;
      this.autoSelectTransporters = rfq.auto_select_transporters;
      this.bidEndTimeValue = rfq.bid_end_time_value;
      this.loiWithChallengePrice = rfq.loi_with_challenge_price;
      this.isEnableWithdrawBid = rfq.is_enable_withdraw_bid;
      this.cargoInfo = new CargoInfo(rfq.cargo_info);
      this.isNew = rfq.is_new;
      this.l1Hits = rfq.l1_hits;
      this.serviceType = rfq.service_type;
      this.trips = (rfq.trip_details.trips || []).map((trip) => {
         return new Trip(trip);
      });
      this.groups = rfq.docs_and_transporters.transporters.groups.map((group) => {
         return new Group(group);
      });
      this.transporters = rfq.docs_and_transporters.transporters.transporter_details.map((transporter) => {
         return new Transporter(transporter);
      });
      this.biddingDetails = new BiddingDetails(rfq.bidding_and_payments);
      this.created = rfq.created;
      this.vehicleType = rfq.vehicleType;
      this.vehicleTypeName = rfq.vehicleTypeName;
      this.documents = (rfq.docs_and_transporters || {}).docs || [];
      this.activity = rfq.activity || {};
      this.supplier_name = rfq.supplier_name || '';
      this.project_id = (rfq.project_details || {}).project_id || '';
      this.po_number = (rfq.project_details || {}).po_number || '';
      this.hits = rfq.hits;
      this.bids = rfq.bids;
      this.bidding_type = rfq.bidding_type;
      this.rfqNumber = rfq.rfq_number;
      this.paymentBy = rfq.payment_by;
      this.paymentBasis = rfq.pricing_basis;
      this.isAllTransporters = rfq.docs_and_transporters.transporters.is_all_transporters;
      this.subplant_name = rfq.subplant_name;
      this.approverEmail = rfq.approval_matrix_level || [];
      this.branchName = rfq.branch_name;
      this.branchId = rfq.branch_id;
      if(rfq.branch_name) {
         localStorage.setItem('branchDetail', JSON.stringify({ branch_name: rfq.branch_name, branch_id: rfq.branch_id}));
      }
      this.approverMessage = rfq.approver_message;

      this.subPlantsForTk11 = rfq.subplant_name;
      this.tkFailureCount = rfq.tk_failure_count;
      this.tkSuccessCount = rfq.tk_success_count;
      this.multiLevelMovementType = rfq.multi_level_movement_type;
      this.shippingType = rfq.shipping_type;
      this.otherCosts = rfq.includes_other_charges || false;
      this.includesOtherCharges = rfq.includes_other_charges;
      this.secondaryContractType = rfq.secondary_contract_type;
      this.loiApproverEmails = rfq.loi_approver_emails || [];
      this.approvalMatrixEmails = rfq.approval_matrix_emails || [];
      this.loiPeriodApplicable = rfq.configurable_loi_period || false;
      this.loiAcceptancePeriod = rfq.loi_acceptance_period || '02:00';
      this.otherCharges = (rfq.courier_common_charges || []).map(oCharge => {
                              return new Trip(oCharge);
                           });
		this.courierTatWeight = rfq.courier_tat_weight;
      this.courierPriceWeight = rfq.courier_price_weight;
      this.shippingType = rfq.shipping_type;
      this.transporterIds = rfq.transporter_ids;
      this.transportersCount = rfq.transporter_ids && rfq.transporter_ids.length || 0;
      this.isRfqClosed = rfq.is_rfq_closed || false;
      this.contracting_type = rfq.contracting_type;
      this.contegory_type = rfq.contegory_type;
      this.minimumBiddersToCreateRfq = rfq.minimum_bidders_to_create_rfq || false;
      this.minimumBiddersCountToCreateRfq = rfq.minimum_bidders_count_to_create_rfq || '';
      this.rfqTypeLtc= rfq.rfq_type_ltc;
      this.isShowObdsDetails = rfq.is_show_obds_details || false;
      this.enableRouteDescription =rfq.is_enable_route_description || false;
      this.enabledObdsFilter = rfq.enabled_obds_filter || false;
      this.temp_max = rfq.temp_max;
      this.temp_min = rfq.temp_min;
      this.temp_name = rfq.temp_name;
      this.pricing_basis_qbr_rate = rfq.pricing_basis_qbr_rate;
      this.pricing_bassis_with_qbr_rate_id = rfq.pricing_bassis_with_qbr_rate_id;
      this.pricing_bassis_with_qbr_rate_name = rfq.pricing_bassis_with_qbr_rate_name;
      this.fuelName = rfq.fuel_name;
      this.fuelType = rfq.fuel_type;
      this.pricing_basis_qbr_rate = rfq.pricing_basis_qbr_rate;
      this.pricing_bassis_with_qbr_rate_id = rfq.pricing_bassis_with_qbr_rate_id;
      this.pricing_bassis_with_qbr_rate_name = rfq.pricing_bassis_with_qbr_rate_name;
      this.approver_names = rfq.approver_names || [];
      this.chatBoxEnable = rfq.chatBoxEnable || false;
      this.shareOfBusiness = rfq.shareOfBusiness || false;
      this.approver_price = rfq.approver_price || [];
      this.approver_email_list = rfq.approver_email_list || [];
      this.dph_approver_email_list = rfq.dph_approver_email_list || []; 
      this.user_email = rfq.user_email;
      this.vehicle_list = rfq.vehicle_list || [];
      this.existingRfq = rfq.existing_rfq || 0;
      this.contract_docs = rfq.contract_docs || [];
      this.offline_contract = rfq.offline_contract;
      this.created_indents = rfq.created_indents;
      this.activeContractCountTrip = rfq.activeContractCountTrip;
      this.expiredContractCountTrip = rfq.expiredContractCountTrip;
      this.dph_approver_price = rfq.dph_approver_price || [];
      this.activeContractCountBid = rfq.activeContractCountBid;
      this.expiredContractCountBid = rfq.expiredContractCountBid;
      this.cpAcceptorRejectTime = rfq.cpAcceptorRejectTime;
      this.original_rfq_number = rfq.original_rfq_number || undefined;
      this.original_rfq_id = rfq.original_rfq_id || undefined;
      this.dphApprovalMatrixNames = rfq.dph_approver_names || [];
      this.dphloiApproverEmails = rfq.dph_loi_approver_emails || [];
      this.dphapprovalMatrixEmails = rfq.dph_approver_matrix_emails || [];
      this.dphApproverEmail = rfq.dph_approval_matrix || [];
      this.dph_approver_names = rfq.dph_approver_names || [];
      this.event_rfq_wishlist = rfq.event_rfq_wishlist || '';
      this.is_average_lpp_approval = rfq.is_average_lpp_approval;
      this.bid_extension_count = rfq.bid_extension_count;
      this.bid_extension_approvers = rfq.bid_extension_approvers || [];
      this.bid_extension_request = rfq.bid_extension_request;
      this.bid_extension_request_by = rfq.bid_extension_request_by;
      this.bid_extension_request_remarks = rfq.bid_extension_request_remarks;
      this.bid_extension_request_time = rfq.bid_extension_request_time;
      this.bid_extension_request_urls = rfq.bid_extension_request_urls;
      this.requested_bidding_end_time = rfq.requested_bidding_end_time;
      this.event_contract = rfq.event_contract;
      this.totalBidExtension = rfq.totalBidExtension;
      this.biddingCategoryId = rfq.biddingCategoryId;
      this.liveBidTransporterAddition = rfq.liveBidTransporterAddition || false;
      this.loi_document = rfq.loi_document || [];
      this.disposal_contract_type=rfq.disposal_contract_type||'';
      this.is_percentage_base_approval = rfq.is_percentage_base_approval;
      this.shipmentId = rfq.shipment_id;
      this.rfq_re_bidding_end = rfq.rfq_re_bidding_end;
      this.reactivate_tk11 = rfq.reactivate_tk11;
      this.cancel_cp = rfq.cancel_cp;
      this.percentage_trips_count = rfq.percentage_trips_count;
      this.biddingPercentageSolution = rfq.is_bidding_percentage_solution;
      this.dispatchDestination = rfq.dispatch_destination;
      this.contactPersonAtSite = rfq.contact_person_at_site;
      this.contactPersonNumberAtSite = rfq.contact_person_number_at_site;
      this.projectNumber = rfq.project_number;
      this.site = rfq.site;
      this.requisitionNumber = rfq.requisition_number;
      this.prDate = rfq.pr_date || new Date().getTime();
      this.country = rfq.country || (rfq.rfq_type == 8 ? 'Cameroon' : '');
      this.wbs = rfq.wbs;
      this.approvalNoteNo = rfq.approval_note_number;
      this.approvedBudget = rfq.approved_budget;
      this.consumeBudget = rfq.consume_budget;
      this.balanceToConsume = rfq.balance_to_consume;
      this.deliveryDays = rfq.delivery_days || {};
      this.payment_terms_name = rfq.payment_terms_name;
      this.activity = rfq.activity;
      this.trips_error_logs = rfq.trips_error_logs;
      this.service_orders = rfq.service_orders || [];
      this.shippingTypeName = rfq.shipping_name;
      this.eximIncoTerms = rfq.exim_inco_terms || "";
      this.bid_increment_percentage_type=rfq.bid_increment_percentage_type;
      this.bid_increment_percentage=rfq.bid_increment_percentage;
      this.is_rfq_price_update = rfq.is_rfq_price_update;
      this.is_rfq_toll_price_update = rfq.is_rfq_toll_price_update;
      this.toll_tax_denominator = rfq.toll_tax_denominator 
      this.toll_tax_percentage = rfq.toll_tax_percentage 
      this.toll_tax_price = rfq.toll_tax_price
      this.toll_tax_diff_price = rfq.toll_tax_diff_price
      this.toll_tax_url = rfq.toll_tax_url
      this.toll_tax_approvers = rfq.toll_tax_approvers
      this.packing_type_name = rfq.packing_type_name
   };

   setIsDraft = (isDraft) => {
      this.isDraft = isDraft;
   }
   seRFQType = (type) => {
      this.type = type;
   }
   setRFQType = (type) => {
      this.type = type;
   }
   addTrip = (trip = new Trip()) => {
      this.trips.push(trip)
   }
   setGroups = (groups) => {
      this.groups = groups;
   }
   setTransporters = (transporters) => {
      this.transporters = transporters;
   }
   setDocuments = (documents) => {
      this.documents = documents;
   }
   addDocument = (document) => {
      this.documents.push(document);
   }
   removeDocument = (index) => {
      this.documents.splice(index, 1);
   }
   setId = (id) => {
      this.id = id;
   }
   setIsAllTransporters = (value) => {
      this.isAllTransporters = value;
   }
   setSubPlants = (subPlants) => {
      this.subplant_name = subPlants;
   }
   setContractingType = (contractType) => {
      this.contracting_type = contractType;
   }
   setCategoryTypeType = (categoryType) => {
      this.contegory_type = categoryType;
   }

   setProcurementDetails = (value, name) => {
      this[name] = value;
   }

   setPRDate = (value) => {
      this.prDate = value;
   }

   setDeliveryDays = (value) => {
      this.deliveryDays = value || {}
   }
   setEximIncoTerms = (eximIncoTerms) => {
      this.eximIncoTerms = eximIncoTerms;
   }
   
   getApiData = () => {
      // const branchDetail = localStorage.getItem('branchDetail') && JSON.parse(localStorage.getItem('branchDetail'));

      const branchDetail = localStorage.getItem('branchDetail')
      const name = (branchDetail && branchDetail.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
      return {
         rfq_id: this.id,
         event_id: this.event_id,
         rfq_type: this.type,
         is_draft: this.isDraft,
         branch_id: name.branch_id ? name.branch_id : undefined,
         branch_name: name.branch_name ? name.branch_name : undefined,
         rfq_details: this.rfqDetails.getApiData(),
         cargo_info: this.cargoInfo.getApiData(),
         bidding_and_payments: this.biddingDetails.getRFQApiData(),
         subplant_name: this.subplant_name,
         contracting_type : this.contracting_type,
         contegory_type : this.contegory_type,
         original_rfq_number : this.original_rfq_number,
         original_rfq_id : this.original_rfq_id,
         exim_inco_terms: this.eximIncoTerms,
         packing_type_name: this.packing_type_name,
         supplier_name: this.supplier_name,
         po_number: this.po_number,
         packing_type_name: this.packing_type_name,
         docs_and_transporters: {
            transporters: {
               is_all_transporters: this.isAllTransporters,
               groups: this.groups.map((group) => {
                  return group.getApiData(group)
               }),
               transporter_details: this.transporters.map((transporter) => {
                  return transporter.getApiData()
               }),
               transporter_ids: Array.from(new Set(flattenDeep((this.groups || []).map((group) => {
                  return (group.transporters || []).map((transporter) => { return transporter.id })
               })).concat((() => {
                  return this.transporters.map((transporter) => {
                     return transporter.id;
                  })
               })())))
            },
            docs: this.documents
         },
         ...this.type === 8 ? {
            dispatch_destination: this.dispatchDestination,
            contact_person_at_site: this.contactPersonAtSite,
            contact_person_number_at_site: this.contactPersonNumberAtSite,
            project_number: this.projectNumber,
            site: this.site,
            requisition_number: this.requisitionNumber,
            pr_date: this.prDate,
            country: this.country,
            wbs: this.wbs,
            approval_note_number: this.approvalNoteNo,
            approved_budget: this.approvedBudget,
            consume_budget: this.consumeBudget,
            balance_to_consume: this.balanceToConsume,
            delivery_days: this.deliveryDays,
            activity: this.activity
         } : null
      }
   }
}
